import Jenjang from "../../../../../components/categories/siakad/lms/data_jenjang/Home";
export default function Home() {
  
  return (
    <Jenjang />
  );
}
